import "./styles/filter";
import { Filter } from "./scripts/filter";

export default Filter;
